export default __webpack_public_path__ + "static/16-vaporwave-49dc778a9f583c40180a2043b5e00b9e.png";